import { t } from '@lingui/core/macro';
export const USER_MUST_SAVE_ERROR_KEY = '__initialFormError';
export const getUserMustSaveErrorMessage = (): string =>
  t`Please edit the form to continue.`;
